module.exports = __webpack_public_path__ + "static/media/search-white.8398b03d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search-white.svg
// module id = 1409
// module chunks = 1